import { render, staticRenderFns } from "./location_permission.vue?vue&type=template&id=3f05848c&scoped=true&"
import script from "./location_permission.vue?vue&type=script&lang=js&"
export * from "./location_permission.vue?vue&type=script&lang=js&"
import style0 from "./location_permission.vue?vue&type=style&index=0&id=3f05848c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f05848c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContent } from 'vuetify/lib/components/VContent';
installComponents(component, {VBtn,VContent})
